// Import utils
import { setActiveStep, getDocumentElement } from '../Utils/Utils';
import { ScrollToTop } from './ScrollToTop';

const StartCalcLink = document.getElementById('startCalcLink');

/**
 * Create the individual section steps.
 * 
 * @param   {object}      options 
 * 
 * @returns {object}
 */
const CreateBottomStepNavigation = options => {
    const Steps = options.steps;
    const Back = getDocumentElement(options.selectors.back);
    const Next = getDocumentElement(options.selectors.next);
    const StepText = getDocumentElement(options.selectors.stepText);
    let maxSteps = null;

    /**
     * Loop through all steps on load, set the step numbers and 
     * ensure the first step is shown.
     * 
     * @returns {void}
     */
    const __mount = () => {
        Steps.forEach((step, i) => {
            const Count = i + 1;
            step.setAttribute('data-step', Count);
            step.setAttribute('aria-hidden', true);

            if (Count === 1) {
                setActiveStep(Steps, options.classes.active);
                window.currentStep = 1;
            }
        });

        // Set the maximum number of steps available,
        // used to enabled/disable the nav buttons.
        maxSteps = Steps.length;

        // Set the step indicator text
        __setStepText();
    };

    /**
     * Set the step navigation indicator text.
     * 
     * @returns {void}
     */
    const __setStepText = () => {
        StepText.innerText = `Step ${window.currentStep} / ${maxSteps}`;
    };

    /**
     * Show/hide buttons based on current step using visibility.
     * 
     * @returns {void}
     */
    const __updateButtons = () => {
        Back.style.visibility = (window.currentStep === 1) ? 'hidden' : 'visible';
        Next.style.visibility = (window.currentStep === maxSteps) ? 'hidden' : 'visible';
    };

    /**
     * Global updater function to sync UI with currentStep.
     * 
     * @returns {void}
     */
    const updateBottomNav = () => {
        if (window.currentStep >= 1 && window.currentStep <= maxSteps) {
            setActiveStep(Steps, options.classes.active);
            __setStepText();
            __updateButtons();
        }
    };

    /**
     * Bind the event listeners — custom and click.
     * 
     * @returns {void}
     */
    const __bind = () => {
        Back.addEventListener('click', e => {
            e.preventDefault();

            if (window.currentStep > 1) {
                window.currentStep -= 1;
                updateBottomNav();

                // Sync top nav if available
                window.updateTopNav?.();
                
                ScrollToTop();
            }
        });

        Next.addEventListener('click', e => {
            e.preventDefault();

            if (window.currentStep < maxSteps) {
                window.currentStep += 1;
                updateBottomNav();

                // Sync top nav if available
                window.updateTopNav?.();
                
                ScrollToTop();
            }
        });
    };

    /**
     * Trigger a click on the Next button from 'Start Farm Water Calculator' link
     */
    if (StartCalcLink) {        
        StartCalcLink.addEventListener('click', e => {
            e.preventDefault();
            Next.click();
        });
    }

    /**
     * Publicly exposed init function.
     * 
     * @returns {void}
     */
    const init = () => {
        if (Back && Next && Steps && StepText) {
            __mount();
            __bind();

            // Sync UI on first load
            updateBottomNav();

            // Expose bottom nav update globally
            window.updateBottomNav = updateBottomNav;
        } else {
            console.warn('Missing components for Farm Calculator steps.');
        }
    };

    return Object.freeze({ init });
};

export default CreateBottomStepNavigation;
